import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function ViewSchedule() {
  const location = useLocation();
  const navigate = useNavigate();
  const userID = sessionStorage.getItem("TRCUserId");
  const [scheduleData, setScheduleData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const getSchedule = async () => {

    try {
      const response = await axios.post(
        "https://api.trucoo.in/marketing/get-schedules/",
        { userId: userID },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );
      console.log(response.data);
      if (response.data.status === "success") {
        setScheduleData(response.data.data);
        setFilteredData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching schedule:", error.response || error.message);
    }
  };

  useEffect(() => {
    getSchedule();
  }, [userID]); // Fetch data when clientId changes

  useEffect(() => {
    if (selectedDate) {
      const filtered = scheduleData.filter((schedule) => {
        const scheduleDate = schedule.schedule.scheduleDate.split(" ")[0];
        return scheduleDate === selectedDate;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(scheduleData);
    }
  }, [selectedDate, scheduleData]);

  const handleViewReport = (schedule) => {
    window.location = `/report-schedule?id=${schedule}`;
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <h4 className="box-title">Employee Schedule</h4>
                <p className="mb-0 box-subtitle">View Schedule Data</p>

                <div className="d-flex justify-content-between">
                  <input
                    type="date"
                    className="form-control w-25"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => navigate("/add-schedule")}
                  >
                    Add Schedule
                  </button>
                </div>
              </div>

              <div className="box-body">
                <div className="table-responsive">
                  <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                    <thead>
                      <tr className="text-dark">
                        <th>S.No</th>
                        <th>Employee Name</th>
                        <th>Client Name</th>
                        <th>Schedule Date</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Remarks</th>
                        <th>Date Added</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((schedule, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{schedule.employee.employeeName}</td>
                            <td>{schedule.client.name}</td>
                            <td>{schedule.schedule.scheduleDate}</td>
                            <td>{schedule.schedule.type}</td>
                            <td>{schedule.schedule.status}</td>
                            <td>{schedule.schedule.remarks}</td>
                            <td>{schedule.schedule.date}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-success"
                                onClick={() => handleViewReport(schedule.schedule.id)}
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9}>No Schedule Data Available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ViewSchedule;
